import { RoleType } from './permissions.types';
import { roleTypes } from './permissions.config';

import { Maybe, Role } from '@iss/libs/graphql';

export const isRoleOfType = (role: Maybe<Role>, ...testRoleTypes: RoleType[]): boolean => role != null
  ? testRoleTypes.some(roleType => roleTypes[role] === roleType)
  : false;
